<router-outlet></router-outlet>
<ngx-spinner bdColor = "rgba(255, 255, 255, 0.6)" size="large" color = "#D2462D" type="ball-scale-multiple"></ngx-spinner>
